var version = "10.90.0";

export { version as v };
//# sourceMappingURL=package-bc5dbdf8.js.map
